import ENUM from '../ENUM'
import ChartType from '../model/CharType'
import RankType from '../model/RankType'

export default function (question) {
    const filters = [
        {
            groupId: 'general',
            name: ENUM().chartType,
            options: ChartType.getOptions('OD'),
        },
        {
            name: ENUM().comparisonSurveyIds,
        },
        {
            groupId: 'general',
            name: ENUM().ranking,
            // first item in array is the default
            options: RankType.getOptions(),
        },
        {
            name: ENUM().locked,
            options: [
                {
                    label: '',
                    value: false,
                    checked: false,
                    name: ENUM().locked,
                },
            ],
            filter: () => (
                question.optionSet.options.some(({ isLocked }) => isLocked)
            ),
        },
    ].filter(({ filter }) => (
        typeof filter !== 'function'
        || filter()
    ))

    return {
        kind: 'QuestionSlide',
        filters,
        references: [ENUM().pageQuestionId],
    }
}
